/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Route } from 'framework/routing';
import { READ_PAYROLL_REPORTS } from 'domain/finance/payroll/generatedPayrolls/useGeneratedPayrollsService';
import GeneratedPayrollListPage from 'domain/finance/payroll/generatedPayrolls/List';
import { ProtectedRouter } from 'infrastructure/routing';
import { getGeneratedPayrollsListUrl, getGeneratedPayrollsRouterPath, useGeneratedPayrollsRoute } from './route';

const GeneratedPayrollsRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useGeneratedPayrollsRoute();

  return (
    <ProtectedRouter basePath={getGeneratedPayrollsListUrl()}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_PAYROLL_REPORTS}>
              <GeneratedPayrollListPage />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

GeneratedPayrollsRouter.getRouterPath = getGeneratedPayrollsRouterPath;

export default GeneratedPayrollsRouter;
